<template>
  <b-form-group
    :label="custom.label_name"
    label-for="preview"
    :label-class="{'required':custom.is_required == 0 ? false : true,'display-none':displayclass}"
  >
    <textarea
      @blur="assignvalue(customvalue)"
      class="form-control"
      :disabled="disabled"
      v-model="customvalue"
      :placeholder="custom.placeholder"
      v-if="custom.datatype=='textarea'"
    ></textarea>

    <v-select
      :clearable="customvalue!=''&&customvalue!=null"
      @input="assignvalue(customvalue),$event==null?customvalue='':''"
      v-else-if="custom.datatype=='select'"
      label="label"
      index="value"
      v-model="customvalue"
      :options="custom.options"
      :placeholder="custom.placeholder"
      :disabled="disabled"
    ></v-select>
    <DatePicker
      input-class="form-control"
      @input="selectDate($event,custom.default_value),assignvalue(customvalue)"
      :format="$AppDetails.organization.date_format"
      v-else-if="custom.datatype=='date'"
      style="width:100% !important;"
      :placeholder="custom.placeholder"
      lang="en"
      v-model="customvalue"
      :disabled="disabled"
    >
      <i class="fa fa-calendar text-dark" slot="calendar-icon" />
    </DatePicker>
    <b-form-checkbox
      @change="assignvalue($event)"
      v-else-if="custom.datatype=='checkbox'"
      unchecked-value=" "
      value="1"
      v-model="customvalue"
      :placeholder="custom.placeholder"
    >{{custom.label_name}}</b-form-checkbox>
    <b-input-group
      v-else-if="custom.datatype=='amount'"
      :prepend="orgCurrency"
      class="mb-2 mr-sm-2 mb-sm-0 product_currency"
    >
      <b-input
        @blur="assignvalue(customvalue)"
        class="form-control"
        v-model="customvalue"
        :disabled="disabled"
        :placeholder="custom.placeholder"
      />
    </b-input-group>
    <input
      @blur="assignvalue(customvalue)"
      class="form-control"
      v-else
      :disabled="disabled"
      v-model="customvalue"
      :placeholder="custom.placeholder"
    />
  </b-form-group>
</template>
<script>
import vSelect from "vue-select";
import { formatDate } from "@/mixins/formatDate"; // global fucntion for calling notification
import DatePicker from "vue2-datepicker"; // vue datepicker
import { EventBus } from "@/event-bus.js";
import { mapGetters } from "vuex";
export default {
  mixins: [formatDate],
  props: ["custom", "disabled", "modelname", "page"],
  components: {
    vSelect,
    DatePicker
  },
  data() {
    return {
      customvalue: ""
    };
  },

  methods: {
    updatecustommodelvalue() {
      this.customvalue = "";
    },
    selectDate(val, modelname) {
      var value =
        val == "" || typeof val == "undefined" || val == null
          ? ""
          : this.formatDate(val);
      this[modelname] = value;
      this.customvalue = value;
    },
    assignvalue(ev) {
      this.$emit("assigncustomvalue", {
        value: ev,
        field: this.custom.field_name
      });
    }
  },
  mounted() {
    EventBus.$on("updatecustommodelvalue", this.updatecustommodelvalue); // to trigger the method from parentcomponent
    var field = this;
    var modelname =
      (field.custom.datatype == "decimal" ||
        field.custom.datatype == "amount" ||
        field.custom.datatype == "percent") &&
      field.modelname &&
      !isNaN(field.modelname)
        ? parseFloat(field.modelname)
        : field.modelname;
    field.customvalue =
      (field.page == "settings" && isNaN(modelname)) ||
      modelname == "" ||
      typeof modelname == "undefined"
        ? field.modelname
        : JSON.parse(JSON.stringify(modelname));
    if (
      field.custom.datatype == "decimal" ||
      field.custom.datatype == "amount" ||
      field.custom.datatype == "percent"
    ) {
      this.$emit("assigncustomvalue", {
        value:
          field.customvalue == "" || isNaN(parseFloat(field.customvalue))
            ? ""
            : parseFloat(field.customvalue),
        field: this.custom.field_name
      });
    }
  },

  computed: {
    displayclass() {
      return this.$route.meta.search == true ? true : "";
    },
    ...mapGetters(["orgCurrency"])
  }
};
</script>